import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoInsuranceCoverageStatusOverviewEmailEditTemplate } from 'themes/application/niko-insurance-coverage-status-overview/pages';
import { InsuranceCoverageStatusOverviewEmailEditViewStore } from 'application/insurance-coverage-status-overview/stores';

@setCurrentView((rootStore) => new InsuranceCoverageStatusOverviewEmailEditViewStore(rootStore), 'insuranceCoverageStatusOverviewEmailEditViewStore')
@observer
class NikoInsuranceCoverageStatusOverviewEmailEdit extends React.Component {
    render() {
        return <NikoInsuranceCoverageStatusOverviewEmailEditTemplate {...this.props} />
    }
}

export default NikoInsuranceCoverageStatusOverviewEmailEdit;
